// extracted by mini-css-extract-plugin
export default {"container":"clear-chat-button_container__50t4e","disabled":"clear-chat-button_disabled__0VQcn"};